import React from 'react';

interface CharCountProps {
    value: string | null | undefined;
    max: number;
    /** Tells what is counted when it isn't the visible text, e.g. "vrátane formátovania" for editor HTML. */
    note?: string;
    className?: string;
}

const formatCount = (count: number) => count.toLocaleString('sk-SK');

/** Live "used / max" counter for a length-limited field; turns amber near the limit and red past it. */
const CharCount: React.FC<CharCountProps> = ({ value, max, note, className }) => {
    const length = value?.length ?? 0;
    const state = length > max ? ' st-char-count--over' : length >= max * 0.9 ? ' st-char-count--near' : '';

    return (
        <span
            className={`st-char-count${state}${className ? ` ${className}` : ''}`}
            title={`${formatCount(length)} z ${formatCount(max)} povolených znakov${note ? ` ${note}` : ''}`}
        >
            {formatCount(length)} / {formatCount(max)}
        </span>
    );
};

export default CharCount;
